export function isValidMMDDYYYY(dateStr) {
    // Check pattern MM/DD/YYYY
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
    if (!regex.test(dateStr))
        return false;
    // Parse components
    const [monthStr, dayStr, yearStr] = dateStr.split('/');
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);
    // Create Date object
    const date = new Date(year, month - 1, day);
    // Validate exact match (e.g., to avoid 02/30 becoming 03/01)
    return (date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day);
}
export function isSupportedDataType(supportedTypes, type) {
    return supportedTypes.map(t => t.toLowerCase()).includes(type.toLowerCase());
}
export function isValidExchangeTickerSymbol(symbol) {
    if (typeof symbol !== "string")
        return false;
    const parts = symbol.split(":");
    if (parts.length !== 2)
        return false;
    const [exchange, ticker] = parts;
    return exchange.length > 0 && ticker.length > 0;
}
export function isValidCurrency(currency) {
    if (typeof currency !== "string")
        return false;
    const s = currency.trim();
    // Reject any whitespace anywhere (spaces, tabs, etc.)
    if (/\s/.test(s))
        return false;
    // Special token (case-insensitive)
    if (s.toLowerCase() === "trading_currency")
        return true;
    // ISO-like: letters only, 3+ chars, case-insensitive
    return /^[a-z]{3,}$/i.test(s);
}
export function isValidCurrencyPairSymbol(symbol) {
    if (typeof symbol !== "string" || symbol.includes(" "))
        return false;
    const parts = symbol.split(":");
    if (parts.length !== 2)
        return false;
    const [base, quote] = parts;
    return isValidCurrency(base) && isValidCurrency(quote);
}
export function isValidDateInput(date) {
    if (date.includes("/"))
        return isValidMMDDYYYY(date);
    const serial = Number(date);
    return !isNaN(serial) && Number.isInteger(serial) && serial > 0;
}
//# sourceMappingURL=args-validators.js.map